
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"13.4"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 14299"}},[_c('path',{attrs:{"data-name":"Path 3457","d":"M1.204 5.879l5.621 6.726a.207.207 0 0 0 .347 0l5.621-6.726-.221.284a3.4 3.4 0 0 0 .663-1.453 4.731 4.731 0 0 0 .063-.695 3.159 3.159 0 0 0-6.22-.915h-.126A3.2 3.2 0 0 0 3.888.7 3.258 3.258 0 0 0 .699 4.047a5.164 5.164 0 0 0 .063.695 3.4 3.4 0 0 0 .663 1.453","fill":"none","stroke":"#444","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"1.4","opacity":".87"}})])])
          )
        }
      }
    